
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/search",
      function () {
        return require("private-next-pages/[market]/[language]/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/search"])
      });
    }
  